export default "/images/crosshair.svg?722ef8db835b506a741de6cc55af6663";